export interface Service {
  id: string;
  slug: string;
  title: string;
  shortDesc: string;
  longDesc: string;
  icon: string;
  image: string;
  benefits: string[];
  features: string[];
  price: string;
  duration: string;
  safetyNote: string;
}

export const services: Service[] = [
  {
    id: '1',
    slug: 'chimney-cleaning',
    title: 'Chimney Cleaning',
    shortDesc: 'Professional chimney sweep and inspection services to keep your fireplace safe and efficient all year long in Jacksonville, FL.',
    longDesc: 'Our certified chimney technicians perform thorough chimney cleaning and inspections for Jacksonville homeowners. We remove creosote buildup, debris, and blockages that can cause dangerous chimney fires. Regular chimney cleaning is essential for home safety, efficiency, and peace of mind.',
    icon: 'ri-fire-line',
    image: 'https://public.readdy.ai/ai/img_res/f16f5e923d6979607b3c9e347666bd0f.jpg',
    benefits: ['Prevents dangerous chimney fires', 'Improves fireplace efficiency', 'Removes creosote buildup', 'Extends chimney lifespan', 'Identifies structural issues early', 'Improves indoor air quality'],
    features: ['Level I & II inspections', 'Creosote removal', 'Debris and blockage clearing', 'Cap and damper inspection', 'Video camera inspection available', 'Written inspection report'],
    price: 'Starting at $149',
    duration: '1–2 hours',
    safetyNote: 'Creosote is highly flammable — annual chimney cleaning is recommended by the National Fire Protection Association.',
  },
  {
    id: '2',
    slug: 'air-duct-cleaning',
    title: 'Air Duct Cleaning',
    shortDesc: 'Complete HVAC air duct cleaning to eliminate dust, allergens, and contaminants for healthier indoor air quality in your Jacksonville home.',
    longDesc: 'BBM Services provides professional air duct cleaning for Jacksonville homeowners and businesses. Our process removes accumulated dust, mold, pet dander, allergens, and debris from your entire HVAC system — improving air quality, reducing energy costs, and helping those with allergies breathe easier.',
    icon: 'ri-wind-line',
    image: 'https://readdy.ai/api/search-image?query=HVAC%20air%20duct%20cleaning%20professional%20technician%20using%20powerful%20vacuum%20equipment%20to%20clean%20interior%20ductwork%2C%20modern%20home%2C%20close%20up%20of%20clean%20and%20dirty%20duct%20comparison%2C%20professional%20gear%2C%20clinical%20clean%20aesthetic%2C%20soft%20indoor%20lighting&width=800&height=600&seq=svc002&orientation=landscape',
    benefits: ['Reduces dust and allergens', 'Improves HVAC efficiency', 'Lowers energy bills', 'Helps allergy and asthma sufferers', 'Eliminates musty odors', 'Extends HVAC system lifespan'],
    features: ['Full system inspection', 'High-powered vacuum extraction', 'All vents and returns cleaned', 'Sanitization treatment available', 'Before & after photos', 'Air quality improvement guarantee'],
    price: 'Starting at $249',
    duration: '3–5 hours',
    safetyNote: 'The EPA recommends air duct cleaning when ducts are visibly contaminated with mold, vermin, or significant debris.',
  },
  {
    id: '3',
    slug: 'dryer-vent-cleaning',
    title: 'Dryer Vent Cleaning',
    shortDesc: 'Thorough dryer vent cleaning to prevent fire hazards and restore your dryer\'s performance and efficiency in Jacksonville, FL.',
    longDesc: 'Clogged dryer vents are the leading cause of home dryer fires. BBM Services clears lint buildup and blockages from your entire dryer vent line, reducing fire risk, cutting drying times, and extending the life of your appliance. A quick, affordable service every Jacksonville homeowner needs.',
    icon: 'ri-flashlight-line',
    image: 'https://readdy.ai/api/search-image?query=dryer%20vent%20cleaning%20service%20technician%20removing%20lint%20buildup%20from%20residential%20dryer%20duct%2C%20close%20up%20of%20lint%20removal%20from%20vent%20pipe%2C%20utility%20room%20setting%2C%20professional%20tools%20and%20equipment%2C%20safety%20focused%2C%20clean%20white%20laundry%20room%20background&width=800&height=600&seq=svc003&orientation=landscape',
    benefits: ['Reduces dryer fire risk by 90%', 'Cuts drying time in half', 'Lowers energy costs', 'Extends dryer lifespan', 'Prevents carbon monoxide buildup', 'Quick service — 45 minutes'],
    features: ['Full vent line inspection', 'Complete lint removal', 'Blockage clearing', 'Vent cap cleaning', 'Performance test after service', 'Fire safety check included'],
    price: 'Starting at $99',
    duration: '45–90 minutes',
    safetyNote: 'The U.S. Fire Administration reports 2,900 dryer fires annually — most caused by failure to clean the vent.',
  },
];

export const serviceAreas: string[] = [
  'Jacksonville', 'Jacksonville Beach', 'Neptune Beach', 'Atlantic Beach',
  'Ponte Vedra Beach', 'Orange Park', 'Fleming Island', 'Middleburg',
  'St. Augustine', 'Ponte Vedra', 'Fernandina Beach', 'Yulee',
  'Callahan', 'Macclenny', 'Green Cove Springs', 'Palatka',
  'Mandarin', 'Southside', 'Riverside', 'Avondale',
  'San Marco', 'Baymeadows', 'Deerwood', 'Nocatee',
];
